export const INSERT_VISIBLE = 'INSERT_VISIBLE'
export const REMOVE_VISIBLE = 'REMOVE_VISIBLE'
export const RESET_VISIBLE_POSITIONS = 'RESET_VISIBLE_POSITIONS'
export const INSERT_VISIBLE_ITEM = 'INSERT_VISIBLE_ITEM'
export const REMOVE_VISIBLE_ITEM = 'REMOVE_VISIBLE_ITEM'
export const RESET_VISIBLE_LIST = 'RESET_VISIBLE_LIST'



// WEBPACK FOOTER //
// ./src/store/actions/visibility.js